import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter,
} from '@/components/ui/alert-dialog';

const fmt = (iso) => new Date(iso).toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

const ConflictDialog = ({ conflict, onResolve }) => {
  const detail = conflict?.detail || {};
  const protectedHit = (detail.conflicts || []).some(c => ['sleep', 'non_negotiable', 'trip'].includes(c.kind));
  return (
    <AlertDialog open={!!conflict} onOpenChange={(o) => !o && onResolve('cancel')}>
      <AlertDialogContent className="bg-[#0A0E27] border border-amber-400/30 text-white" data-testid="conflict-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-amber-300">
            <AlertTriangle size={18} /> That time isn't free
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-300" data-testid="conflict-dialog-message">
            {detail.message}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <ul className="space-y-1 text-sm" data-testid="conflict-dialog-list">
          {(detail.conflicts || []).map((c, i) => (
            <li key={i} className="text-gray-300">• <span className="text-white">{c.label}</span> <span className="text-gray-500">({c.local})</span></li>
          ))}
        </ul>
        {detail.suggested_time && (
          <p className="text-sm text-cyan-300" data-testid="conflict-dialog-suggestion">
            Suggested instead: {fmt(detail.suggested_time)}
            {detail.suggestion_reasons?.length ? <span className="block text-xs text-gray-400 mt-1">{detail.suggestion_reasons.join(' · ')}</span> : null}
          </p>
        )}
        <AlertDialogFooter className="gap-2">
          <button onClick={() => onResolve('cancel')} data-testid="conflict-cancel-btn"
            className="px-4 py-2 rounded-lg text-sm text-gray-300 hover:text-white border border-white/10">Cancel</button>
          {!protectedHit && (
            <button onClick={() => onResolve('force')} data-testid="conflict-force-btn"
              className="px-4 py-2 rounded-lg text-sm text-amber-300 border border-amber-400/30 hover:bg-amber-400/10">Schedule anyway</button>
          )}
          {detail.suggested_time && (
            <button onClick={() => onResolve('suggested')} data-testid="conflict-use-suggestion-btn"
              className="px-4 py-2 rounded-lg text-sm font-semibold text-[#0A0E27]" style={{ background: 'linear-gradient(135deg,#00D9FF,#0EA5E9)' }}>
              Use suggested time
            </button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConflictDialog;
